<script lang="ts">
export default {
  name: 'DataQualityRollupEntityRow',
};
</script>

<script setup lang="ts">
import { DataQualityRollupEntity, DataQualityRule } from '@/types/DataQuality';
import Tooltip from '@/components/v2/Tooltip.vue';

const props = defineProps({
  header: Boolean,
  violation: Object as () => DataQualityRollupEntity,
  policyTypeRules: Array as () => Readonly<DataQualityRule[]>,
  issuingCompanyRules: Array as () => Readonly<DataQualityRule[]>,
  wholesalerRules: Array as () => Readonly<DataQualityRule[]>,
});

function violatedRules(rollupEntity: DataQualityRollupEntity): (DataQualityRule & { violated: boolean })[] {
  let rules;
  switch (rollupEntity.entityType) {
    case 'Policy Type':
      rules = props.policyTypeRules;
      break;
    case 'Issuing Company':
      rules = props.issuingCompanyRules;
      break;
    case 'Wholesaler':
      rules = props.wholesalerRules;
      break;
    default:
      rules = [];
  }

  if (!rules) return [];
  return rules.map(rule => ({
    ...rule,
    violated: Reflect.get(rollupEntity, `rule${rule.value}`) > 0,
  }));
}
</script>

<template>
  <tr>
    <template v-if="header">
      <td class="nosort w-[30%]">Entity</td>
      <td class="nosort w-[55%]">Entity Type</td>
      <td class="nosort w-[15%]">Violations</td>
      
    </template>
    <template v-else-if="violation">
      <td class=" w-[30%]">{{ violation.entity }}</td>
      <td class=" w-[55%]">{{ violation.entityType }}</td>
      <td class=" w-[15%]">
        <div class="inline-block" v-for="(rule) in violatedRules(violation)" :key="rule.key">
          <Tooltip
            v-if="rule.violated"
            position="bottom"
            :text="`Rule: ${rule.desc} — Resolution: ${rule.resolution}`">
            <span
              class="flex bg-primary w-5 h-5 text-white mr-0.5 rounded-full text-[10pt] font-bold justify-center items-center scale-[85%] cursor-pointer">
              <span class="w-fit h-fit font-mono">{{ rule.value }}
              </span>
            </span>
          </Tooltip>
        </div>
      </td>
    </template>
  </tr>
</template>
